import { Courier } from '../../interfaces/Courier'
import { CourierAction } from '../actions/courierActions'
import { GET_COURIERS_EXITO } from '../types/courierActionsTypes'

export interface CourierState {
  couriersState: {
    couriers?: Courier[] | undefined
    error?: string | undefined
  }
}

const initialState: CourierState = {
  couriersState: { couriers: [], error: '' }
}

export const courierReducer = (
  state: CourierState = initialState,
  action: CourierAction
): CourierState => {
  if (action.type === GET_COURIERS_EXITO) {
    return {
      ...state,
      couriersState: {
        couriers: action.couriers,
        error: action.error
      }
    }
  }
  return state
}
